module.exports = __webpack_public_path__ + "img/logo_FAstation.15a58a8c.svg";